// @flow
import type { LeafRuleProps } from 'types/rule-types';

import moment from 'moment';

import React, { Component } from 'react';
import { Dropdown } from 'semantic-grab-ui/src';
import TimePicker from 'rc-time-picker';

import {
  operatorOptions,
} from 'omega-rtc/components/rule-builder/utils';

const TIME_FORMAT = 'hh:mm a';

export default class TimeRule extends Component {
  props: LeafRuleProps;

  constructor(props: LeafRuleProps) {
    super(props);
    this.state = {
      rhs: props.rule.rhs,
    };
  }

  handleRuleOperatorSelect = (event: Object, dropdown: Object) => {
    const { rule } = this.props;
    const newRule = Object.assign({}, rule, { operator: dropdown.value });
    this.props.onRuleChange(newRule);
  }

  handleRhsChangeTime = (value: Object, timePosition: number) => {
    const { rule } = this.props;
    rule.rhs[timePosition] = moment(value).diff(moment(value).startOf('day'), 's');
    this.props.onRuleChange(rule);
  }

  render() {
    const { rule, ruleType, isSelected } = this.props;
    const from = rule.rhs[0];
    const to = rule.rhs[1];
    const fromTime = moment().startOf('day').add(from, 's');
    const toTime = moment().startOf('day').add(to, 's');

    return (
      <span>
        <span>{ruleType.noun}</span>
        <span>
          &nbsp;&nbsp;
          <Dropdown
            inline
            options={operatorOptions(ruleType)}
            defaultValue={rule.operator}
            onChange={this.handleRuleOperatorSelect}
            disabled={!isSelected}
          />
          &nbsp;&nbsp;
        </span>
        <TimePicker
          showSecond={false}
          defaultValue={fromTime}
          onChange={(val) => this.handleRhsChangeTime(val, 0)}
          format={TIME_FORMAT}
          use12Hours
          disabled={!isSelected}
        />
        &nbsp;to&nbsp;
        <TimePicker
          showSecond={false}
          defaultValue={toTime}
          onChange={(val) => this.handleRhsChangeTime(val, 1)}
          format={TIME_FORMAT}
          use12Hours
          disabled={!isSelected}
        />
      </span>
    );
  }
}
